<div class="page-container">
  <div class="overlay-color">
    <div class="form-container">
      <!-- logo -->
      <div class="container-logo">
        <img class="login-logo" src="assets/logos/logo-agenda-group-7479.svg" />
      </div>

      <!--Message-->
      <div class="forgot-msg-container">
        <p class="forgot-msg-title">Esqueceu a senha?</p>
        <p class="forgot-msg-info">
          Informe o e-mail cadastrado na plataforma para redefinir sua senha.
        </p>
      </div>

      <!-- form -->
      <form
        [formGroup]="fgForm"
        (ngSubmit)="onSubmit()"
        *ngIf="!loading"
        class="form-group-page"
      >
        <div *ngIf="hasErrors" class="login-invalid">
          <span class="material-icons-outlined login-invalid-icon">
            warning_amber
          </span>
          <span class="login-invalid-text">{{ error403Message }}</span>
        </div>
        <!-- campo login -->
        <mat-form-field appearance="outline" class="form-field-email">
          <mat-label class="form-label-email">Email</mat-label>
          <input
            matInput
            formControlName="email"
            type="email"
            autocomplete="email"
            readonly="false"
            class="borda"
          />
          <mat-error *ngIf="fgForm.get('email')?.hasError('email')"
            >Email inválido</mat-error
          >
          <mat-error *ngIf="fgForm.get('email')?.hasError('required')"
            >Informe o email</mat-error
          >
        </mat-form-field>

        <button
          mat-raised-button
          class="btn-forgot-password"
          [disabled]="fgForm.invalid || !fgForm.dirty"
        >
          Redefinir senha
        </button>
      </form>
      <mat-progress-bar
        *ngIf="loading"
        mode="indeterminate"
        class="effect-mid"
      ></mat-progress-bar>
    </div>
  </div>
</div>
